import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.HasClimateControlledUnits,
  LocationVarKey.HasHumidityControlledUnits,
  LocationVarKey.ClimateControlName,
  { key: LocationVarKey.ClimateControlHighValue, hideIf: IS_NOT_EQUAL(LocationVarKey.HasClimateControlledUnits, "1") },
  { key: LocationVarKey.ClimateControlLowValue, hideIf: IS_NOT_EQUAL(LocationVarKey.HasClimateControlledUnits, "1") },
  { key: LocationVarKey.HumidityControlHighValue, hideIf: IS_NOT_EQUAL(LocationVarKey.HasHumidityControlledUnits, "1") },
  { key: LocationVarKey.HumidityControlLowValue, hideIf: IS_NOT_EQUAL(LocationVarKey.HasHumidityControlledUnits, "1") },
  LocationVarKey.FeatureClimateControl1,
  LocationVarKey.FeatureClimateControl2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Climate Control
      </PageHeader>

      <SwitchRow {...page} keyName={LocationVarKey.HasClimateControlledUnits} label="Climate Control" />
      <SwitchRow {...page} keyName={LocationVarKey.HasHumidityControlledUnits} label="Humidity Control" />
      <InputRow {...page} keyName={LocationVarKey.ClimateControlName} label="Climate Control Display Name" />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasClimateControlledUnits, "1")}
        keyName={LocationVarKey.ClimateControlHighValue}
        label="Climate Control High Value"
      />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasClimateControlledUnits, "1")}
        keyName={LocationVarKey.ClimateControlLowValue}
        label="Climate Control Low Value"
      />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasHumidityControlledUnits, "1")}
        keyName={LocationVarKey.HumidityControlHighValue}
        label="Humidity Control High Value"
      />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasHumidityControlledUnits, "1")}
        keyName={LocationVarKey.HumidityControlLowValue}
        label="Humidity Control Low Value"
      />

      <SectionHeader {...page}> Climate Control Message</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FeatureClimateControl1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.FeatureClimateControl2}
        enableSwitchVar={LocationVarKey.FeatureClimateControl2Enabled}
      />
    </>
  );
}
